
import { defineComponent, PropType, reactive, computed, watch } from "vue";
import LPRankingUser from "@/components/common_presentational/LPRankingUser.vue";
import RankingFirst from "@/components/common_presentational/rankings/RankingFirst.vue";
import RankingSecond from "@/components/common_presentational/rankings/RankingSecond.vue";
import RankingThird from "@/components/common_presentational/rankings/RankingThird.vue";
import { RankingUserInfo } from "@/entities/ranking";
import { Event } from "@/entities/event";
import Talent from "@/entities/talent";

export default defineComponent({
  name: "LPRanking",
  components: {
    LPRankingUser,
    RankingFirst,
    RankingSecond,
    RankingThird,
  },
  props: {
    rankingUsers: {
      type: Array as PropType<RankingUserInfo[]>,
      required: true,
    },
    event: {
      type: Object as PropType<Event>,
      required: true,
    },
    tallyStartDays: {
      type: Number,
      default: 0,
    },
    tallyEndDays: {
      type: Number,
      default: 0,
    },
    maxCount: {
      type: Number,
      default: 10,
    },
  },
  setup(props) {
    const state = reactive({
      isLoading: true,
      date: "",
      rankingUsers: [] as Array<RankingUserInfo>,
    });

    // 日本時間の日付(yyyy-mm-dd)を取得
    const getJSTDate = (date: Date): string => {
      return date.toLocaleDateString("en-CA", { timeZone: "Asia/Tokyo" });
    };
    // 日付文字列に日数を加算
    const addDays = (dateStr: string, days: number): string => {
      const d = new Date(dateStr + "T00:00:00+09:00");
      d.setDate(d.getDate() + days);
      return getJSTDate(d);
    };

    const isTallying = computed(() => {
      const sd = props.event.startDate;
      const ed = props.event.endDate;
      if (!sd || !ed) return false;

      const todayJST = getJSTDate(new Date());
      const startJST = getJSTDate(sd);
      const endJST = getJSTDate(ed);

      if (props.tallyStartDays > 0) {
        const tallyStartEnd = addDays(startJST, props.tallyStartDays - 1);
        if (todayJST >= startJST && todayJST <= tallyStartEnd) return true;
      }
      if (props.tallyEndDays > 0) {
        const tallyEndEnd = addDays(endJST, props.tallyEndDays - 1);
        if (todayJST >= endJST && todayJST <= tallyEndEnd) return true;
      }
      return false;
    });

    watch(
      () => props.event,
      () => {
        const sd = props.event.startDate;
        const ed = props.event.endDate;
        const startDate = `${sd.getFullYear()}年${sd.getMonth() + 1}月${sd.getDate()}日`;

        const hasDiffMoreAYear = sd.getFullYear() != ed.getFullYear();
        const endDate = `${hasDiffMoreAYear ? ed.getFullYear() + "年" : ""}${ed.getMonth() + 1}月${ed.getDate()}日`;

        state.date = `${startDate} ~ ${endDate}`;
      }
    );
    watch(
      () => props.rankingUsers,
      () => {
        const seen = new Set<string>();
        const uniqueRankingUsers = props.rankingUsers.filter((user) => {
          const id = user.influencer.influencer.talentID;
          if (seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        for (let i = 0; i < props.maxCount; i++) {
          if (i + 1 <= uniqueRankingUsers.length) {
            state.rankingUsers.push(uniqueRankingUsers[i]);
          } else {
            state.rankingUsers.push(
              new RankingUserInfo({
                influencer: {
                  influencer: new Talent({
                    displayName: "",
                    eventDate: 0,
                    genre: [],
                    images: [],
                    introduction: "",
                    talentID: "",
                    liveStatus: 0,
                  }),
                  points: 0,
                }, 
                
              })
            );
          }
        }
        state.isLoading = false;
      }
    );

    return {
      state,
      isTallying,
    };
  },
});
